import { createFeatureSelector, createSelector } from '@ngrx/store';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';
import {State, vmixServersFeatureKey} from '../reducers/vmix-servers.reducer';

export const selectVmixServersState = createFeatureSelector<State>(
  vmixServersFeatureKey
);

export const getProductionInstancesRecord = createSelector(
  selectVmixServersState,
  (state: State): ProductionInstance[] => state.record
);

export const getProductionInstancesLoaded = createSelector(
  selectVmixServersState,
  (state: State): boolean => state.loaded
);

export const getProductionInstancesLoading = createSelector(
  selectVmixServersState,
  (state: State): boolean => state.loading
);

export const getLoadProductionInstancesError = createSelector(
  selectVmixServersState,
  (state: State): unknown => state.error
);
